import { Link } from 'react-router-dom';
import { courseBenefits } from '@/mocks/masterCourseData';
import { useTranslation } from 'react-i18next';

const BENEFIT_COUNT = 6;
const benefitIndices = Array.from({ length: BENEFIT_COUNT }, (_, i) => i);

function renderParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).map((part, index) => (
    <p key={index} className={className}>
      {part}
    </p>
  ));
}

export default function CourseBenefits() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {renderParagraphs(
            t('coursesMaster.benefits.label'),
            'text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label'
          )}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesMaster.benefits.title')}
          </h2>
          <div className="gold-line mx-auto mb-4"></div>
          {renderParagraphs(
            t('coursesMaster.benefits.lead'),
            'text-[16px] text-foreground-600 tracking-[0.04em] max-w-xl mx-auto leading-relaxed'
          )}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-4xl mx-auto mb-8">
          {benefitIndices.map((index) => (
            <div
              key={index}
              className={`flex items-start gap-4 p-5 border border-background-200/60 bg-background-50 group hover:border-accent-500/20 transition-colors duration-300 ${
                index === 0 ? 'sm:col-span-2 lg:col-span-1 border-accent-500/15 bg-accent-500/[0.02]' : ''
              }`}
            >
              <span className="w-9 h-9 flex items-center justify-center flex-shrink-0">
                <i className={`${courseBenefits[index]?.icon} text-accent-600 text-lg group-hover:text-accent-500 transition-colors duration-300`}></i>
              </span>
              <div>
                <h4 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-1.5">
                  {t(`coursesMaster.benefits.${index}.title`)}
                </h4>
                {renderParagraphs(
                  t(`coursesMaster.benefits.${index}.description`),
                  'text-[15px] text-foreground-600 leading-relaxed tracking-[0.03em]'
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="text-center">
          <Link to="/benefits" className="inline-flex items-center gap-2 text-[14px] text-accent-600 hover:text-accent-500 tracking-[0.08em] transition-colors duration-300">
            <span>{t('coursesMaster.benefits.detailLink')}</span>
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
